import { ISelectItem } from "winfakt-vue-components";
import { LoadCsvRowsModalState, SaleEditState } from "./sale-edit-state";
import { SaleEditButtons } from "@/models/user-configs/sale-settings";
import { i18n } from "@/setup/i18n-setup";
import { SaleService } from "@/services";
import { AsyncFunctionConstructor } from "../common";
import * as services from "@/services";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";

export class SaleEditStateButtonsList {
	private isPurchaseType:boolean;
	private contactGroupName:string;

	public printPreview:ISelectItem<Function>;
	public toggleImportedSales:ISelectItem<Function>;
	public toggleImportedSalesFromClients:ISelectItem<Function>;
	public editExtraFields:ISelectItem<Function>;
	public editDocuments:ISelectItem<Function>;
	public toggleImportSaleRows:ISelectItem<Function>;
	public toggleProfit:ISelectItem<Function>;
	public toggleStocks:ISelectItem<Function>;
	public contactExtraInfoEdit:ISelectItem<Function>;
	public applyDiscountOnDocument:ISelectItem<Function>;
	public createPublicUrl:ISelectItem<Function>;
	public attachToCar:ISelectItem<Function>;
	public autoAddProductsWithNotEnoughStock:ISelectItem<Function>;
	public updatePricesToActualPrices:ISelectItem<Function>;
	public sortRows:ISelectItem<Function>;
	public deleteAllSaleRows:ISelectItem<Function>;
	public loadRowsFromCsv:ISelectItem<Function>;
	public toggleHiddenRows:ISelectItem<Function>;
	public toggleAutoHideNewRows:ISelectItem<Function>;
	public updateCurrencyRate:ISelectItem<Function>;
	public createCalendarEvent:ISelectItem<Function>;
	public scriptButtons:ISelectItem<Function>[] = [];

	// eslint-disable-next-line max-lines-per-function
	public constructor(state:SaleEditState){
		this.isPurchaseType = state.isPurchaseType;
		this.contactGroupName = state.getContactGroupName();
		this.printPreview = {
			text: "print-preview",
			key: SaleEditButtons.PRINT_PREVIEW,
			value: ()=>state.printPreview(),
			icon: "print",
			disabled: state.isPrintingPreview
		};
		this.toggleImportedSales = {
			text: this.isPurchaseType ? "purchase-document-import" : "document-import",
			key: SaleEditButtons.IMPORT_SALE,
			value: ()=>state.openImportSales(),
			icon: "file-import"
		};
		this.toggleImportedSalesFromClients = {
			text: "sale-row-import",
			key: SaleEditButtons.IMPORT_SALE_ROWS,
			value: ()=>state.openImportSaleRows(),
			icon: "file-import",
		};
		this.editExtraFields = {
			text: "edit-extra-fields",
			key: SaleEditButtons.EDIT_EXTRA_FIELDS,
			value: ()=>state.editExtraFieldsModal = true,
			icon: "sticky-note"
		};
		this.editDocuments = {
			text: "documents",
			key: SaleEditButtons.EDIT_ATTACHMENTS,
			value: ()=>state.documentsModal = true,
			icon: "paperclip"
		};
		this.toggleImportSaleRows = {
			text: "open-import-sale-rows",
			key: SaleEditButtons.IMPORT_SALE_ROWS,
			value: ()=>state.openImportSaleRows(),
			icon: "list"
		};
		this.toggleProfit = {
			text: state.profitVisible ? "profit-hide" : "profit-show",
			key: SaleEditButtons.TOGGLE_PROFIT,
			value: ()=>state.toggleProfit(),
			icon: "euro-sign"
		};
		this.toggleStocks = {
			text: state.stockInfoVisible ? "stock-info-hide" : "stock-info-show",
			key: SaleEditButtons.TOGGLE_STOCK_INFO,
			value: ()=>state.toggleStockInfo(),
			icon: "cubes"
		};
		this.contactExtraInfoEdit = {
			text: "contact-extra-info-edit",
			key: SaleEditButtons.OPEN_CONTACT_EXTRA_INFO_EDIT,
			value: ()=>state.openContactExtraInfoEdit(),
			icon: "address-card"
		};
		this.applyDiscountOnDocument = {
			text: "apply-discount-on-document",
			key: SaleEditButtons.APPLY_DISCOUNT_ON_SALE,
			value: ()=>state.applyDiscountModal = true,
			icon: "tag"
		};
		this.createPublicUrl = {
			text: "public-url-create",
			key: SaleEditButtons.CREATE_PUBLIC_URL,
			value: ()=>state.createPublicLink(),
			icon: "link"
		};
		this.attachToCar = {
			text: "attach-to-car",
			key: SaleEditButtons.CONNECT_TO_CAR,
			value: ()=>state.carSelectData.isOpen = true,
			icon: "car"
		};
		this.autoAddProductsWithNotEnoughStock = {
			text: "auto-add-products-with-not-enough-stock",
			key: SaleEditButtons.AUTO_ADD_PRODUCTS_WITH_NOT_ENOUGH_STOCK,
			value: ()=>state.addProductsWithNotEnoughInStockBySelectedSupplier([]),
			icon: "pallet"
		};
		this.updatePricesToActualPrices = {
			text: "update-all-rows-to-latest-prices",
			key: SaleEditButtons.UPDATE_PRICES_TO_ACTUAL_PRICES,
			value: ()=>state.updateAllRowsToLatestPrices(),
			icon: "tags"
		};
		this.sortRows = {
			text: "sort-rows",
			key: SaleEditButtons.SORT_SALE_ROWS,
			value: ()=>state.sortRowsModalOpen = true,
			icon: "sort"
		};
		this.deleteAllSaleRows = {
			text: "delete-all-sale-rows",
			key: SaleEditButtons.DELETE_ALL_SALE_ROWS,
			value: ()=>state.deleteAllSaleRows(),
			icon: "trash"
		};
		this.loadRowsFromCsv = {
			text: "load-rows-from-csv",
			key: SaleEditButtons.LOAD_SALE_ROWS_FROM_CSV,
			value: ()=>state.csvRowsModalState = LoadCsvRowsModalState.OPEN,
			icon: "file-csv"
		};
		this.toggleHiddenRows = {
			text: state.hiddenRowsAreInvisble ? "show-hidden-rows" : "hide-hidden-rows",
			key: SaleEditButtons.TOGGLE_HIDDEN_ROWS,
			value: ()=>state.hiddenRowsAreInvisble = !state.hiddenRowsAreInvisble,
			icon: "eye"
		};
		this.toggleAutoHideNewRows = {
			text: state.addRowsAutoHidden ? "auto-show-new-rows" : "auto-hide-new-rows",
			key: SaleEditButtons.AUTO_HIDE_NEW_ROWS,
			value: ()=>state.addRowsAutoHidden = !state.addRowsAutoHidden,
			icon: state.addRowsAutoHidden ? "eye" : "eye-slash"
		};
		this.updateCurrencyRate = {
			text: "update-currency-rate",
			key: SaleEditButtons.UPDATE_CURRENCY_RATE,
			value: ()=>state.updateCurrencyRate(),
			icon: "sync"
		};
		this.createCalendarEvent = {
			text: state.createCalendarEventState.shouldOpenOnSave ? "create-calendar-event-on-save-active" : "create-calendar-event-on-save",
			key: SaleEditButtons.CREATE_CALENDAR_EVENT,
			value: ()=>state.createCalendarEventState.shouldOpenOnSave = !state.createCalendarEventState.shouldOpenOnSave,
			icon: state.createCalendarEventState.shouldOpenOnSave ? "calendar-check" : "calendar-plus"
		};
		this.scriptButtons = SaleService.saleEditExtraButtonScripts.map(s=>{
			let f = new AsyncFunctionConstructor("state", "services", s.Content);
			return {
				text: s.Name,
				icon: s.Icon,
				key: `script-button-${s.ID}`,
				value: async ()=>{
					await f(state, services);
				}
			};
		});
	}


	public generateButtons(keys:string[]):ISelectItem<Function>[] {
		let allItems = Object.keys(this).filter(k=>{
			let key = k as keyof SaleEditStateButtonsList;
			return typeof(this[key]) == "object" && !Array.isArray(this[key]);
		}).map(k=>this[k as keyof SaleEditStateButtonsList] as ISelectItem<Function>) as any[] as ISelectItem<Function>[];
		allItems.push(...this.scriptButtons);
		return keys.map(k=>{
			return allItems.find(i=>i.key == k);
		}).filter(i=>{
			if (!i) return false;
			if (!this.isPurchaseType && i.key == SaleEditButtons.IMPORT_CLIENT_SALE) return false;
			if (!this.isPurchaseType && i.key == SaleEditButtons.AUTO_ADD_PRODUCTS_WITH_NOT_ENOUGH_STOCK) return false;
			if (i.key == SaleEditButtons.CREATE_CALENDAR_EVENT && !AuthService.hasModule(MODULE.AGENDA)) return false;
			return true;
		}).map(i=>{
			if (!i) return i;
			let text = i.text;
			if (i.key && !i.key.toString().startsWith("script-button-")) {
				text = i18n.t(`components.sales.${i.text.toString()}`, {groupName: this.contactGroupName});
			}
			return {
				...i,
				text
			};
		}) as any[] as ISelectItem<Function>[];
	}
}